import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-resource-object.drag",
  "use": "icon-resource-object.drag-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-resource-object.drag\">\n<circle cx=\"6\" cy=\"4\" r=\"1\" />\n<circle cx=\"6\" cy=\"8\" r=\"1\" />\n<circle cx=\"6\" cy=\"12\" r=\"1\" />\n<circle cx=\"10\" cy=\"4\" r=\"1\" />\n<circle cx=\"10\" cy=\"8\" r=\"1\" />\n<circle cx=\"10\" cy=\"12\" r=\"1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol